'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        text: '',
        type: { type: String, default: '' },
        inputType: { type: String, default: 'text' },
        inpvalue: { type: String, default: '' },
        unfocus: false,
        tabIndex: '',
        loading: { type: Boolean, default: false },
        maxlength: 'off'
    },

    computed: {
        hasText: function hasText() {
            return this.inpvalue.length > 0;
        }
    },
    methods: {
        'inputBlur': function inputBlur(event) {
            this.$dispatch('inputBlur', event);
        },
        'focus': function focus() {
            this.$dispatch('inputFocus');
        }
    },
    watch: {
        unfocus: function unfocus() {
            if (this.unfocus) {
                this.$els.input.blur();
                this.unfocus = false;
            }

            this.$dispatch('updateFocus', this.unfocus);
        },
        inpvalue: function inpvalue() {
            this.$dispatch('update', this.inpvalue);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=input-field><div v-bind:class=\"{ 'loading': loading }\"><input id=\"{{ type }}\" class=\"{{ type }} {{ (hasText) ? 'has-text' : '' }}\" type=\"{{ inputType }}\" tabindex=\"{{ tabIndex}}\" v-model=inpvalue v-el:input=\"\" v-on:focus=focus v-on:blur=inputBlur maxlength=\"{{ maxlength }}\"><label for=\"{{ type }}\">{{ text }}</label></div></div>"
